import {FormikProps, FormikHelpers} from 'formik';
import {notify} from '@gemcook/notification';

import constants from '@constants';
import utils from '@utils';
import {Props} from './types';

export const updateCurrent = async (
  props: Props,
  current: number,
  setIsPaging: React.Dispatch<React.SetStateAction<boolean>>
) => {
  props.actions.notifications.updateActiveNotificationDetails(
    props.notifications.detail.pagination.data,
    props.notifications.detail.pagination.current,
    current,
    props.notifications.detail.pagination.totalPages
  );
  setIsPaging(true);
  await props.actions.notifications.updateCurrentNotificationDetail({
    page: current,
    sort: props.notifications.detail.pagination.sort,
    notificationId: props.match.params.id,
    isSafe: props.notifications.detail.search.isSafe,
    isMinorInjury: props.notifications.detail.search.isMinorInjury,
    isSeriousInjury: props.notifications.detail.search.isSeriousInjury,
    isAnswered: props.notifications.detail.search.isAnswered,
    name: props.notifications.detail.search.names,
    position: props.notifications.detail.search.position,
    organization: props.notifications.detail.search.organization,
  });
  setIsPaging(false);
};

export const addSearchWord = (
  formProps: FormikProps<any>,
  inputFieldName: string,
  searchFieldName: string
) => {
  const inputWord = formProps.values[inputFieldName].trim();
  // 名前欄に入力された文字にスペースが入っていれば分割する
  if (inputFieldName === 'userName' && inputWord) {
    utils.search.splitKeyword(
      'userName',
      formProps.values.userName,
      formProps.values.userNames,
      formProps
    );
    return;
  }
  // 組織欄に入力された文字にスペースが入っていれば分割する
  if (inputFieldName === 'organization' && inputWord) {
    utils.search.splitKeyword(
      'organization',
      formProps.values.organization,
      formProps.values.organizations,
      formProps
    );
    return;
  }
  // 役職欄に入力された文字にスペースが入っていれば分割する
  if (inputFieldName === 'position' && inputWord) {
    utils.search.splitKeyword(
      'position',
      formProps.values.position,
      formProps.values.positions,
      formProps
    );
    return;
  }

  if (inputWord) {
    const searchWords = formProps.values[searchFieldName];
    // 検索キーワードラベルを追加
    searchWords.push({
      text: inputWord,
      id: searchWords.length,
    });
    formProps.setFieldValue(searchFieldName, searchWords);
    formProps.setFieldValue(inputFieldName, '');
  } else {
    return;
  }
};

export const search = async (
  values: any,
  formikHelpers: FormikHelpers<any>,
  props: Props,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  formikHelpers.setSubmitting(true);
  setLoading(true);

  try {
    let isAnswered: any;
    // 未回答にチェックが入っている場合、isAnsweredをfalseにする
    if (values.unAnswered) {
      isAnswered = !values.unAnswered;
    }
    if (values.answered) {
      isAnswered = values.answered;
    }
    // 回答済み、未回答が両方チェックの時、パラメーターを渡さないようにする
    if (values.unAnswered && values.answered) {
      isAnswered = undefined;
    }
    // 送信状況のフラグ
    let isSentSuccess: any;
    // 送信成功にチェックが入っている場合
    if (values.isSuccess) {
      isSentSuccess = true;
    }
    // 送信不可にチェックが入っている場合
    if (values.isFailed) {
      isSentSuccess = false;
    }
    // 送信成功と送信不可両方にチェックが入っている場合
    if (values.isSuccess && values.isFailed) {
      isSentSuccess = undefined;
    }
    // 名前欄に入力されていた場合、検索キーワードに入れる
    if (values.userName) {
      utils.search.splitKeyword(
        'userName',
        values.userName,
        values.userNames,
        formikHelpers
      );
    }
    // 所属組織が入力されていた場合、検索キーワードに追加する
    if (values.organization) {
      utils.search.splitKeyword(
        'organization',
        values.organization,
        values.organizations,
        formikHelpers
      );
    }
    // 役職が入力されていた場合、検索キーワードに追加する
    if (values.position) {
      utils.search.splitKeyword(
        'position',
        values.position,
        values.positions,
        formikHelpers
      );
    }
    // 検索対象のユーザー名の配列を作成
    const names = values.userNames.map((user: any) => user.text);

    // 検索対象の役職の配列を作成
    const positions = values.positions.map((position: any) => position.text);

    // 検索対象の組織の配列を作成
    const organizations = values.organizations.map(
      (organization: any) => organization.text
    );

    await props.actions.notifications.updateCurrentNotificationDetail({
      isSafe: values.isSafe,
      isMinorInjury: values.isMinorInjury,
      isSeriousInjury: values.isSeriousInjury,
      isAnswered,
      isSentSuccess,
      page: 1,
      sort: '-replyDatetime',
      notificationId: props.match.params.id,
      name: names,
      position: positions,
      organization: organizations,
    });

    // 検索条件をStoreに保存
    props.actions.notifications.updateDetailSearchWords({
      names,
      organizations,
      positions,
      isAnswered,
      isSafe: values.isSafe,
      isMinorInjury: values.isMinorInjury,
      isSeriousInjury: values.isSeriousInjury,
    });
  } catch (error) {
    notify(constants.ERRORS.UNKNWON);
  } finally {
    setLoading(false);
    formikHelpers.setSubmitting(false);
  }
};
